module.exports = __webpack_public_path__ + "img/avatar-1642.5629777f.png";